import { render, staticRenderFns } from "./PT091InformationDetailParts.vue?vue&type=template&id=0889bd44&"
import script from "./PT091InformationDetailParts.vue?vue&type=script&lang=js&"
export * from "./PT091InformationDetailParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports